export const SINGLE_THRESHOLD_IRRIGATION_TYPE =
  'Valves::SingleThresholdIrrigation'
export const MULTI_THRESHOLD_IRRIGATION_TYPE =
  'Valves::MultiThresholdIrrigation'

export const SENSOR_THRESHOLD_IRRIGATION_TYPE =
  'Valves::SensorThresholdIrrigation'
